import { FC } from 'react';
import { Section } from './ui/Section';
import { EntryBlock } from './ui/EntryBlock';
import type { Entry } from '../types/cv';

interface Props {
  awards: Entry[];
  title?: string;
  oneLine?: boolean;
}

export const Awards: FC<Props> = ({ awards, title = 'Awards', oneLine = false }) => (
  <Section title={title}>
    {awards.map((award, i) => (
      <EntryBlock
        key={`${award.title}-${i}`}
        entry={award}
        title={award.title ?? award.name}
        role={award.awarder && <span className="cv-sub">{award.awarder}</span>}
        note={award.summary}
        oneLine={oneLine}
      />
    ))}
  </Section>
);

export default Awards;
